import { orderBy } from 'lodash-es';
import useSWR from 'swr';

import { checkEnvironment } from '@/shared/lib';
import { GetPublicationsReturnItemType } from '@/shared/types';

const fetcher = async (url: string) => {
  try {
    const res = await fetch(url, { next: { tags: ['publications'] } });
    if (!res.ok) {
      throw new Error('Failed to fetch');
    }

    return res.json();
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
    throw error;
  }
};

// Custom hook to fetch breed data with SWR
export const useFilterBreedData = (
  animalType: 'all' | 'dog' | 'cat' | undefined,
  pubType: 'all' | 'продажа' | 'дарение' | 'случка' | undefined
) => {
  const publicationsUrl = `${checkEnvironment()}/api/publication/get-publications-paginated?animal-type=${
    animalType ?? 'all'
  }&publication-type=${pubType ?? 'all'}&limit=-1`;

  const {
    data: publicationsData,
    error: publicationsError,
    isLoading: publicationsLoading
  } = useSWR(publicationsUrl, fetcher, {
    revalidateOnReconnect: true,
    revalidateOnFocus: false
  });

  if (publicationsData) {
    const breedCount: Record<string, number> = {};

    (publicationsData.publications as GetPublicationsReturnItemType[]).forEach((pub) => {
      const breed = pub.pet.breed;
      breedCount[breed] = (breedCount[breed] || 0) + 1;
    });

    const sortedBreedCount = orderBy(
      Object.entries(breedCount),
      ([, count]) => count,
      'desc'
    ).reduce(
      (acc, [breed, count]) => {
        acc[breed] = count;
        return acc;
      },
      {} as Record<string, number>
    );

    return {
      breedData: sortedBreedCount,
      isLoading: false,
      error: null
    };
  }

  return {
    breedData: null,
    isLoading: publicationsLoading,
    error: publicationsError
  };
};
